module.exports = __webpack_public_path__ + "img/Plug-active.772c8ca7.png";